import config from '@/assets/config.json';
import api from '../../api/index';
const state = {
    userRegist: {}
}
const mutations = {
    setUserRegist(state, data) {
        state.userRegist = data;
    }
}
const getters = {
    getUserRegist: state => {
        return state.userRegist;
    }
}
const actions = {
    getImgInfo({
        rootState,
        commit
    }, opt) { //获取
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/wx/getImgInfo`, opt).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },









    //==============================



    getPhoneCode({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => { //获取手机验证码
            api.post(`${config.userHttps.api}/apiuser/login/getcode`, opt).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    checkPhoneCode({
        rootState,
        commit
    }, opt) { //核对手机验证码
        return new Promise((resolve, reject) => {
            api.post(`${config.userHttps.api}/apiuser/login/checkcode`, opt).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    uploadBase64({
        rootState,
        commit
    }, opt) { //上传图片
        return new Promise((resolve, reject) => {
            api.post(`${config.centralHttps.api}/api/filesup/codes`, opt).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    buyerSettle({
        rootState,
        commit
    }, opt) { //商家入驻
        return new Promise((resolve, reject) => {
            api.post(`${config.shopHttps.api}/apimerchant/users/register`, opt,{
                headers:{
                    Authorization:'Bearer '+localStorage.getItem("Beitoken")
                  },
            }).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    getSettleUser({
        rootState,
        commit
    }, opt) { //审核失败获取用户信息
        return new Promise((resolve, reject) => {
            api.post(`${config.shopHttps.api}/apimerchant/users/getinfos`, opt).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    outLogin({
        rootState,
        commit
    }, opt) { //退出登入
        return new Promise((resolve, reject) => {
            api.post(`${config.userHttps.api}/apiuser/login/logout`, opt).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    updateSettle({
        rootState,
        commit
    }, opt) { //审核失败修改
        return new Promise((resolve, reject) => {
            api.post(`${config.shopHttps.api}/apimerchant/users/updateinfo`, opt).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    getRecommend({
        rootState,
        commit
    }) { //获取推荐人信息
        return new Promise((resolve, reject) => {
            api.post(`${config.shopHttps.api}/apimerchant/users/getreferrer`).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },


}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}